<div class="row filter-container align-items-center">
  <ng-content select="[search]"></ng-content>

  <ng-content></ng-content>
</div>
